import { Core, Renderer, Transition } from '@unseenco/taxi';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from "gsap/dist/CustomEase";
import { initNavigation } from './components/navigation.js';
import { initGallerySwiper } from './components/gallery-swiper.js';
import { initSearchToggle } from './components/search-toggle.js';
import { initPostCarousel } from './components/post-carousel.js';
import { initPageAccordion } from './components/page-accordion.js';
import { initContentAccordion } from './components/content-accordion.js';
import { initGSAPStackedGallery } from './components/gsapStackedGallery.js';
import { initGSAPHeaderScroll } from './components/gsapHeaderScroll.js';
import { initGSAPEndorphin } from './components/gsapEndorphinScroll.js';
import { initGSAPWordScroll } from './components/gsapWordScroll.js';
import { initGSAPGallery } from './components/gsapGallery.js';
import { initBioDialog } from './components/bioDialog.js';
import { initGSAPSpiralGallery } from './components/gsapSpiralGallery.js';
import { initGSAPIntroGate } from './components/gsapIntroGate.js';
import { initShareDialog } from './components/shareDialog.js';
import { initGSAPElementAnimations } from './components/gsapElementAnimations.js';
import { initGSAPTypewriter } from './components/gsapTypewriter.js';
import { initSidebarNavHighlight } from './components/sidebarNavHighlight.js';
import { initGSAPVerticalText } from './components/gsapVerticalText.js';
import { initGSAPElevatorLetters } from './components/gsapElevatorLetters.js';
import { initGSAPInView } from './components/gsapInView.js';
import { initGSAPTimeline } from './components/gsapTimeline.js';
import { initPopovers } from './components/popovers.js';
import { initSitemapToggle } from './components/sitemapToggle.js';

const initComponents = () => {
	initGSAPHeaderScroll();
	initGSAPSpiralGallery();
	initGSAPTypewriter();
	initNavigation();
	initGallerySwiper();
	initSearchToggle();
	initPostCarousel();
	initPageAccordion();
	initContentAccordion();
	initGSAPStackedGallery();
	initGSAPGallery();
	initBioDialog();
	initGSAPIntroGate();
	initShareDialog();
	initSidebarNavHighlight();
	initGSAPVerticalText();
	initGSAPElevatorLetters();
	initGSAPEndorphin();
	initGSAPInView();
	initGSAPTimeline();
	initGSAPElementAnimations();
	initPopovers();
	initGSAPWordScroll();
	initSitemapToggle();

};

const initPage = () => {
	gsap.registerPlugin(CustomEase);
	gsap.set('.site-transitioner', { y: 0, clipPath: 'circle(0% at 100% 100%)' });
	CustomEase.create("bounceEasing", "0.5,1.6,0.5,1");
	const ease = gsap.parseEase("bounceEasing");

	class DefaultRenderer extends Renderer {
		onEnter() {
			initComponents();
		}
	}

	class BlurTransition extends Transition {
		onLeave({ from, done }) {
			gsap.to(from, {
				opacity: 0,
				filter: 'blur(20px)',
				scale: 1.01,
				y: -5,
				duration: 0.50,
				transformOrigin: 'center center',
				ease: 'power2.inOut',
				onComplete: done,
			});
		}

		onEnter({ to, done }) {
			gsap.fromTo(
				to,
				{ opacity: 0, y: -10, filter: 'blur(10px)' },
				{
					opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.4, ease: 'power2.out', onComplete: () => {
						gsap.set(to, { clearProps: 'all' });
						done();
						ScrollTrigger.refresh();
					}
				}
			);
		}
	}


	const taxi = new Core({
		renderers: {
			default: DefaultRenderer,
		},
		transitions: {
			default: BlurTransition,
		},
	});

	taxi.on('NAVIGATE_IN', ({ to, trigger }) => {
		window.scrollTo({ top: 0, behavior: 'instant' });
	});

	taxi.on('NAVIGATE_END', ({ to }) => {
		document.querySelectorAll('.global-nav__link').forEach(link => {
			link.removeAttribute('aria-current');
			const currentURL = new URL(to.finalUrl, window.location.origin);
			if (link.getAttribute('href') === currentURL.pathname) {
				link.setAttribute('aria-current', 'page');
			}
		});
	});

}

document.addEventListener("DOMContentLoaded", () => {
	document.fonts.ready.then(function () {
		initPage();
	});
});